import { ArrowUp, CheckCircleLine, Download } from '@factorialco/f0-react/icons/app'
import { PaymentPageRoutesFragment } from 'generated/resources/graphql'

import formatCurrency from 'modules/core/lib/formatCurrency'
import i18n from 'modules/core/lib/i18n'
import { ResourceHeadersPropsWithActions } from 'modules/core/lib/navigation/types'

import { statusLabelType, statusText } from 'modules/banking/lib/mappers'
import {
  shouldShowPayWithSepaTransfer,
  supportsSepaPayment,
} from 'modules/banking/lib/paymentHelpers'

export const buildPaymentHeaderComponentProps = (
  payment: PaymentPageRoutesFragment,
  canSeeSepaTransferAction: boolean
): ResourceHeadersPropsWithActions => {
  const lastPaymentExecution = payment.paymentExecutions[payment.paymentExecutions.length - 1]
  const totalTransfers = lastPaymentExecution?.transfersConnection.totalCount || 0
  const supportsSepa = supportsSepaPayment(
    payment.bank_account?.account?.providerConfiguration?.services
  )
  const showPayActions = shouldShowPayWithSepaTransfer(
    payment.status,
    supportsSepa,
    totalTransfers > 0
  )

  const seeSepaTransferAction = supportsSepa && canSeeSepaTransferAction

  const actions: Array<{ label: string; icon: typeof Download; key: string }> = []

  if (seeSepaTransferAction && showPayActions) {
    actions.push({
      label: i18n.t('banking.payments.pay_with_sepa_transfer'),
      icon: ArrowUp,
      key: 'pay_with_sepa_transfer',
    })
  }

  if (!seeSepaTransferAction && lastPaymentExecution) {
    actions.push({
      label: i18n.t('banking.payments.download_sepa_file'),
      icon: Download,
      key: 'download_sepa_file',
    })
  }

  const paymentInProgress = payment.status === 'in_progress'
  if (!seeSepaTransferAction && paymentInProgress) {
    actions.push({
      label: i18n.t('banking.payments.mark_as_paid'),
      icon: CheckCircleLine,
      key: 'mark_as_paid',
    })
  }
  return {
    title: payment.label ?? '',
    status: {
      label: '',
      text: statusText(payment.status),
      variant: statusLabelType(payment.status),
    },
    secondaryActions: actions,
    metadata: [
      {
        label: i18n.t('banking.payments.detail_total_amount'),
        value: {
          type: 'text',
          content: formatCurrency(payment.amountCents, payment.currency),
        },
      },
      {
        label: i18n.t('banking.payments.detail_total_count'),
        value: {
          type: 'text',
          content: totalTransfers + '',
        },
      },
    ],
  }
}
